/*
 * @Author: 张天昊
 * @Date: 2024-05-22 11:28:23
 * @LastEditTime: 2024-06-06 13:45:35
 * @LastEditors: 张天昊
 * @Description:
 * @FilePath: /Mobile/src/pages/itineraryUniversal/utils.js
 */
import { getScroller, getElementTop } from 'vant/es/utils/dom/scroll';
import { scrollTopTo } from '@/utils/scroll';

export function genEmptyTextPlaceholder(content) {
  return content || '-';
}

export function isEncryptStr(str) {
  return str.includes('*');
}

export function triggerScroll(el, offset = 0, callback) {
  const scroller = getScroller(el);
  const scrollTop = getElementTop(el) + offset;
  scrollTopTo(scroller, scrollTop, 0.3, callback);
}

export function transformEnumValue2Label(enumObj) {
  return Object.entries(enumObj).reduce((prev, curr) => {
    const [label, value] = curr;
    prev[value] = label;
    return prev;
  }, {});
}

export function formatPriceValue(value) {
  if (typeof value === 'number') {
    return `${value}元`;
  } else {
    return '****';
  }
}
